import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import './LoanModal.css'; // Add styles for modal

const LoanModal = ({ isOpen, onClose, children }) => {
  // Create a div element for the modal
  const modalRoot = document.getElementById('root');
  const modalElement = document.createElement('div');

  useEffect(() => {
    if (isOpen) {
      // Append modal to root element
      modalRoot.appendChild(modalElement);
      return () => {
        // Clean up by removing the modal element
        modalRoot.removeChild(modalElement);
      };
    }
  }, [isOpen, modalElement, modalRoot]);

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-content"
        onClick={(e) => e.stopPropagation()} // Prevent closing modal on content click
      >
        <button className="modal-close" onClick={onClose}>
          &times;
        </button>
        {children}
      </div>
    </div>,
    modalElement
  );
};

export default LoanModal;
